/* Code generated with AutoHTML Plugin for Figma */
import HelpSvg from "../../assets/icons/help_smail.svg?react";
import TelegramSvg from "../../assets/icons/telegram.svg?react";
import WhatsAppSvg from "../../assets/taiga-uikit/icons/message.svg?react";
import { Link } from "../../components/link/link";
import Title from "../../components/texts/title";
import { _size, _sizeHeading, url_telegram } from "../../core/core";
import "./help.css";

export const Help = ({ ...props }) => {
  return (
    <div className="help">
      <div className="help-header">
        <Title type={_sizeHeading.h2_2}>Остались вопросы?</Title>
      </div>

      <div className="help-body">
        <div className="help-body-left">
          <svg
            className="help-vector"
            viewBox="0 0 195 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M77.789 -46.7007C62.5051 -38.4183 52.3833 -22.7987 39.6613 -11.1902C31.2251 -3.4926 21.6085 2.66336 13.3015 10.5194C9.24456 14.3561 2.92801 19.765 1.41369 26.3517C0.428253 30.6377 8.56828 30.9332 9.25654 31.0143C20.3781 32.3266 31.1248 31.4571 40.7583 28.7652C50.9459 25.919 58.8887 20.0762 67.5565 14.8311C77.3685 8.89326 88.2506 4.79346 98.8497 0.140582C99.8724 -0.308465 120.859 -9.13021 120.993 -8.78384C121.984 -6.22714 116.706 0.429184 116.487 0.739739C109.767 10.281 101.863 18.6213 94.3023 27.253C79.5572 44.0871 65.7022 62.0687 49.0091 76.6502C47.5754 77.9024 33.3421 86.2458 43.7836 88.1602C53.6313 89.9657 63.0273 88.1614 71.5667 86.4114C84.5088 83.7596 96.5595 79.558 107.847 73.8463C121.103 67.1381 132.852 56.8723 148.161 53.6599C149.863 53.3026 156.755 50.4154 156.406 55.5727C155.8 64.5218 151.77 72.4824 148.517 79.4573C141.618 94.2505 133.694 108.589 124.882 121.657C117.012 133.33 106.098 141.214 96.2521 150.6C95.6331 151.19 93.5934 152.622 94.485 152.475C99.7045 151.615 104.943 150.715 110.012 149.529C128.002 145.321 143.922 137.092 161.022 131.178C165.434 129.652 169.69 127.95 174.72 127.974"
              stroke="#BBFF33"
              strokeWidth="39"
              strokeLinecap="round"
            />
          </svg>
          <svg
            className="help-vector"
            viewBox="0 0 195 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M77.789 -46.7007C62.5051 -38.4183 52.3833 -22.7987 39.6613 -11.1902C31.2251 -3.4926 21.6085 2.66336 13.3015 10.5194C9.24456 14.3561 2.92801 19.765 1.41369 26.3517C0.428253 30.6377 8.56828 30.9332 9.25654 31.0143C20.3781 32.3266 31.1248 31.4571 40.7583 28.7652C50.9459 25.919 58.8887 20.0762 67.5565 14.8311C77.3685 8.89326 88.2506 4.79346 98.8497 0.140582C99.8724 -0.308465 120.859 -9.13021 120.993 -8.78384C121.984 -6.22714 116.706 0.429184 116.487 0.739739C109.767 10.281 101.863 18.6213 94.3023 27.253C79.5572 44.0871 65.7022 62.0687 49.0091 76.6502C47.5754 77.9024 33.3421 86.2458 43.7836 88.1602C53.6313 89.9657 63.0273 88.1614 71.5667 86.4114C84.5088 83.7596 96.5595 79.558 107.847 73.8463C121.103 67.1381 132.852 56.8723 148.161 53.6599C149.863 53.3026 156.755 50.4154 156.406 55.5727C155.8 64.5218 151.77 72.4824 148.517 79.4573C141.618 94.2505 133.694 108.589 124.882 121.657C117.012 133.33 106.098 141.214 96.2521 150.6C95.6331 151.19 93.5934 152.622 94.485 152.475C99.7045 151.615 104.943 150.715 110.012 149.529C128.002 145.321 143.922 137.092 161.022 131.178C165.434 129.652 169.69 127.95 174.72 127.974"
              stroke="#BBFF33"
              strokeWidth="39"
              strokeLinecap="round"
            />
          </svg>
          <HelpSvg></HelpSvg>
          <Title type={_sizeHeading.h3}>
            Служба заботы ответит на&nbsp;ваши вопросы
          </Title>
        </div>

        <div className="help-body-right">
          <Link
            link={`?chat=true`}
            isMobileWidth
            icon_right={<WhatsAppSvg />}
            size={_size.M}
          >
            Написать в чат
          </Link>
          <Link
            link={url_telegram}
            isMobileWidth
            icon_right={<TelegramSvg />}
            size={_size.M}
          >
            Написать в Telegram
          </Link>
        </div>
      </div>
    </div>
  );
};
